import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import Loading from '../../shared/components/custom/Loading';
import { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import ClubheartShowcase from './components/ClubheartShowcase';
import GoalSponsorPlanList from './components/GoalSponsorPlanList';
import GoalSponsorPrizeList from './components/GoalSponsorPrizeList';

const GoalSponsorPlanListPage = () => {
  const [loadingSubscriptionPlans, setLoadingSubscriptionPlans] =
    useState(true);
  const [loadingPrizes, setLoadingPrizes] = useState(true);
  const [tab, setTab] = useState(1);
  const p = partial('goalSponsor');

  return (
    <Container>
      <Loading loading={loadingSubscriptionPlans || loadingPrizes} />
      <ClubheartShowcase />
      <NavTab
        activeTab={tab}
        tabs={[p('subscriptionPlans'), p('prizes')]}
        setTab={setTab}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <GoalSponsorPlanList setLoading={setLoadingSubscriptionPlans} />
        </TabPane>
        <TabPane tabId="2">
          <GoalSponsorPrizeList setLoading={setLoadingPrizes} />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default GoalSponsorPlanListPage;
